import loadable from '@loadable/component';

export const TermPage = loadable(/* #__LOADABLE__ */ () => import('./TermPage'));
